export const MIN_TOPUP_AMOUNT = 0.01;
export const MAX_TOPUP_AMOUNT = 1_000_000;

export const amountOptions = [
  2000,
  3000,
  5000,
  10000,
  50000,
  100000,
];
